import {useInfiniteTags} from "@twigsby/client-data";
import {ComboBoxControl, SelectItemType} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect, useState} from "react";

type HasLabelConditionType = {
    name: string;
    defaultValue: any;
    changeCallback: (value: any) => void;
}

const HasTagCondition = (props: HasLabelConditionType) => {
    const { setValue} = useFormContext();

    const { data, status } = useInfiniteTags();
    const [ tagOptions, setTagOptions ] = useState<Array<SelectItemType>>([]);

    const IterateData = () => {
        let NewTagOptions: Array<SelectItemType> = [];

        data?.pages.forEach((page) =>
                page?.data && page.data.filter((tag, index: number) =>
                    tag ? NewTagOptions.push({'label': tag.name, 'value': tag.id}) : null
                )
        );

        setTagOptions(NewTagOptions);
    }

    useEffect(() => {
        if(data) {
            IterateData();
        }
    }, [data]);

    return (
        <ComboBoxControl
            name={props.name}
            placeholder={'Select Tag...'}
            data={tagOptions}
            defaultValues={props.defaultValue ? [props.defaultValue] : undefined}
            loading={status === 'loading'}
            disabled={status === 'error'}
            valueType={'number'}
            forwardValuesCallback={(val) => {
                setValue(props.name, val)
            }}
        />
    )
}

export { HasTagCondition }
